<template>
  <div class="card">
    <div class="header">
      <div style="display: flex;align-items: center;">
        <div class="tag"></div>
        我的达人号
      </div>
    </div>

    <a-tabs default-active-key="tikTok">
      <a-tab-pane key="tikTok" tab="抖音">
        <AuthView pvd="tikTok"/>
      </a-tab-pane>
      <a-tab-pane key="kuaishou" tab="快手">
        <AuthView pvd="kuaishou"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import AuthView from "@/pages/Setting/mine-auth/auth-view.vue";
export default {
  name: "mine-auth",
  components: {
    AuthView
  },
  data() {
    return {
      tiktok: undefined,
      data: [],
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 30px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;

  .tag {
    width: 3px;
    height: 15px;
    background: #FA6400;
    margin-right: 4px;
  }

  .button {
    height: 28px;
    background: #7557FF;
    border-radius: 5px;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 28px;
    padding-left: 8px;
    padding-right: 8px;
    cursor: pointer;
  }
}
</style>
